import styled from 'styled-components'

export const Button = styled.button`
  outline-color: #002d63;
  width: 96px;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: #25a37b;
  flex: 1;
  :disabled {
    background-color: #c7c9c7;
  }
`

export const Text = styled.p`
  font-size: 16px;
  margin: 0;
  line-height: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
